import React from 'react';
import { Dialog } from '@mui/material';
import useWindowWidth from 'components/hooks/useWindowWidth';
import Popper from 'components/interface/Popper/Popper';

interface Props extends Omit<
    React.ComponentProps<typeof Popper>,
    'handleClose'
> {
    onClose: () => void;
}

export function CalendarPopover({
    open,
    onClose,
    children,
    ...popperProps
}: Props) {
    const { isMobile } = useWindowWidth();

    if (isMobile) {
        return (
            <Dialog
                open={open}
                onClose={onClose}
                maxWidth={false}
                PaperProps={{
                    elevation: 8,
                    sx: {
                        m: 1,
                        width: 'fit-content',
                        maxWidth: 'calc(100% - 16px)',
                        maxHeight: 'calc(100dvh - 16px)',
                    },
                }}>
                {children}
            </Dialog>
        );
    }

    return (
        <Popper {...popperProps} open={open} handleClose={onClose}>
            {children}
        </Popper>
    );
}
